'use strict';

const Mn = require('backbone.marionette');
const Tooltip = require('common/ui/view/behavior/tooltip');
const ReadMore = require('common/ui/view/behavior/readmore');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const Template = require('data/ui/template/content/version.hbs');
const OpenURI = require('data/ui/view/content/open-uri');

const ItemView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: Template,
    regions: {
        updatedBy: '.updatedBy',
        'uri': '.uri'
    },
    behaviors: [Tooltip],
    templateContext: function() {
        const contentType = this.model.getMetaData().getContentType();

        return {
            contentType: contentType,
        }
    },
    onRender: function() {
        const updatedBy = this.model.getUpdatedBy();
        if (updatedBy) {
            this.showChildView('updatedBy', new GroupMemberNameView({model: updatedBy}));
        }

        this.showChildView('uri', new OpenURI({
            version: this.model,
            project: this.model.getContent().getProject(),
        }));
    },
});

module.exports = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list',
    childView: ItemView,
    behaviors: {
        ReadMore: {
            behaviorClass: ReadMore,
            showReadMore: function() {
                return this.model.hasNextVersion();
            },
            onReadMore: function() {
                return this.model.getVersionsMore(10);
            }
        }
    }
});



// WEBPACK FOOTER //
// ./data/ui/view/content/version-list.js